// @flow
/** @jsx jsx */

import { isFunction } from 'lodash';

import { jsx } from '@emotion/core';
import { Border, Colors } from '@zapier/theme';

import { type Node } from 'react';

type Props = {
  children?: Node,
  isEditing?: boolean,
  renderAside?: () => Node,
  renderLabel?: () => Node,
};

const containerCss = props => {
  return {
    border: `${Border.size.default} solid ${
      props.isEditing ? Colors.heroine : Colors.adamantium
    }`,
    borderRadius: Border.radius.default,
    padding: 15,
    position: 'relative',
  };
};

const headerCss = {
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'space-between',
  minHeight: 40,
};

const headerLabelCss = {
  display: 'flex',
  alignItems: 'center',

  '> *': {
    marginRight: 20,
  },
};

const sectionCss = {
  marginTop: 20,
};

const PaymentMethod = (props: Props) => (
  <section css={containerCss(props)}>
    <header css={headerCss}>
      <div css={headerLabelCss}>
        {isFunction(props.renderLabel) && props.renderLabel()}
      </div>
      {isFunction(props.renderAside) && props.renderAside()}
    </header>
    {props.isEditing && props.children && (
      <div css={sectionCss}>{props.children}</div>
    )}
  </section>
);

export default PaymentMethod;
